var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2579_10889)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.5C0 5.5975 5.5975 0 12.5001 0C19.4026 0 25.0001 5.5975 25.0001 12.5C25.0001 19.4025 19.4026 25 12.5001 25C5.5975 25 0 19.4025 0 12.5ZM19.989 16.2703C20.3106 15.0478 20.3106 12.5128 20.3106 12.5128C20.3106 12.5128 20.3236 9.96509 19.989 8.74272C19.8088 8.07362 19.2812 7.54586 18.6121 7.3658C17.3896 7.03126 12.5001 7.03126 12.5001 7.03126C12.5001 7.03126 7.61032 7.03126 6.3879 7.35303C5.73159 7.53308 5.19104 8.07362 5.01099 8.74272C4.68922 9.96509 4.68922 12.5 4.68922 12.5C4.68922 12.5 4.68922 15.0478 5.01099 16.2573C5.19124 16.9263 5.71881 17.4542 6.3879 17.6343C7.6231 17.9687 12.5001 17.9687 12.5001 17.9687C12.5001 17.9687 17.3896 17.9687 18.6121 17.647C19.2812 17.467 19.8088 16.9394 19.989 16.2703ZM15.0089 12.5001L10.9429 14.842V10.1583L15.0089 12.5001Z",
    fill: "#4AFEBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2579_10889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.81a30b6c8279a08ad72c98a48f3bd703.svg";
export { ForwardRef as ReactComponent };